export default __webpack_public_path__ + "static/media/ico-mongodb-score-low.7e98f20c.svg";